import * as tslib_1 from "tslib";
import * as React from 'react';
var classNames = require('classnames');
var styles = require('./OptionDescription.scss');
export default function OptionDescription(props) {
    return (React.createElement("p", tslib_1.__assign({}, props, { className: classNames(props.className, styles.description) }), props.children));
}
//# sourceMappingURL=OptionDescription.js.map